module.exports = __webpack_public_path__ + "img/BS13.188d7487.svg";